import { apiOrigin } from "./api_origin";

export const apiRoutes = {
    "getBook": `${apiOrigin}/api/v1/publications/book`,
    "getAccount": `${apiOrigin}/api/v1/publications/account`,
    "postSubscription": `${apiOrigin}/api/v1/publications/subscription`,
};
